"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "siena": {
    "336a14ba": [{
      "hkey": "0121db03",
      "slug": "abbadia-ruffolo",
      "name": "Abbadia-Ruffolo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d6ff9a00",
      "slug": "costafabbri-costalpino",
      "name": "Costafabbri-Costalpino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "c87d2e5a",
      "slug": "petriccio-acquacalda",
      "name": "Petriccio-Acquacalda",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "c87d2e5a",
      "slug": "petriccio-acquacalda",
      "name": "Petriccio-Acquacalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "siena"
    }],
    "0605bd56": [{
      "hkey": "9bbea942",
      "slug": "fuori-porta-camollia",
      "name": "Fuori Porta Camollia",
      "primary": true,
      "skipSearch": false
    }],
    "semicentrale": [{
      "hkey": "9bbea942",
      "slug": "fuori-porta-camollia",
      "name": "Fuori Porta Camollia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "siena"
    }]
  }
};
exports["default"] = _default;